import { Icon } from "@mui/material";
import { BsWalletFill } from "react-icons/bs";
import { GiSettingsKnobs } from "react-icons/gi";
import { MdAttachMoney } from "react-icons/md";
import { FaChartBar } from "react-icons/fa";

// Helper function to get user type from localStorage
const getUserType = () => {
  try {
    const authInfo = localStorage.getItem("authInfo");
    if (authInfo) {
      const parsed = JSON.parse(authInfo);
      return parsed?.principalInfo?.userType;
    }
  } catch (error) {
    console.error("Error getting user type:", error);
  }
  return null;
};

// Routes for regular partners (PARTNER_ORG)
const regularPartnerRoutes = [
  {
    type: "collapse",
    name: "Dashboards",
    key: "ptr",
    noCollapse: true,
    icon: <Icon fontSize="medium">dashboard</Icon>,
    collapse: [
      {
        name: "Dashboard",
        key: "dash",
        route: "ptr/dash",
      },
    ],
  },
  // { type: "title", title: "Ticket" },
  {
    type: "collapse",
    name: "Ticket",
    key: "ADM-Ticket",
    noCollapse: true,
    icon: <Icon fontSize="medium">group-work</Icon>,
    collapse: [
      {
        name: "All Tickets",
        key: "pending-tickets",
        route: "ADM-Ticket/pending-tickets",
      },
    ],
  },
  // { type: "title", title: "Wallet" },
  {
    type: "collapse",
    name: "Wallet",
    key: "wallet",
    noCollapse: true,
    icon: <BsWalletFill />,
    collapse: [
      {
        name: "Payment Dashboard",
        key: "payment-dashboard",
        route: "wallet/payment-dashboard",
      },
    ],
  },
  {
    type: "collapse",
    name: "Account",
    key: "account",
    icon: <Icon>account_circle</Icon>,
    collapse: [
      /* {
        name: "Account Management",
        key: "account-management",
        route: "account/management",
      }, */
      {
        name: "Bank Accounts",
        key: "bank-accounts",
        route: "partner/bank-accounts",
      },
      {
        name: "Statements",
        key: "statements",
        route: "account/statements",
      },
    ],
  },
  {
    type: "collapse",
    name: "Configurations",
    key: "ADM-APPCONFIG",
    icon: <GiSettingsKnobs />,
    collapse: [
      {
        name: "Reset Password",
        key: "reset_password",
        route: "ADM-APPCONFIG/reset_password",
      },
    ],
  },
];

// Routes for channel partners (CHANNEL_PARTNER_ORG)
// Channel partners should NOT see tickets or wallets
// They should only see commission data
const channelPartnerRoutes = [
  {
    type: "collapse",
    name: "Dashboards",
    key: "ptr",
    noCollapse: true,
    icon: <Icon fontSize="medium">dashboard</Icon>,
    collapse: [
      {
        name: "Dashboard",
        key: "dash",
        route: "ptr/dash",
      },
    ],
  },
  // { type: "title", title: "Commission" },
  {
    type: "collapse",
    name: "My Commission",
    key: "commission",
    noCollapse: true,
    icon: <MdAttachMoney />,
    collapse: [
      {
        name: "Dashboard",
        key: "commission-dashboard",
        route: "commission/dashboard",
      },
      {
        name: "Referred Customers",
        key: "commission-customers",
        route: "commission/customers",
      },
      {
        name: "By Service",
        key: "commission-service",
        route: "commission/by-service",
      },
      {
        name: "Payment History",
        key: "commission-history",
        route: "commission/payment-history",
      },
      {
        name: "Monthly Statement",
        key: "commission-statement",
        route: "commission/monthly-statement",
      },
    ],
  },
  {
    type: "collapse",
    name: "Account",
    key: "account",
    icon: <Icon>account_circle</Icon>,
    collapse: [
      /* {
        name: "Account Management",
        key: "account-management",
        route: "account/management",
      }, */
      {
        name: "Bank Accounts",
        key: "bank-accounts",
        route: "partner/bank-accounts",
      },
      {
        name: "Statements",
        key: "statements",
        route: "account/statements",
      },
    ],
  },
  {
    type: "collapse",
    name: "Configurations",
    key: "ADM-APPCONFIG",
    icon: <GiSettingsKnobs />,
    collapse: [
      {
        name: "Reset Password",
        key: "reset_password",
        route: "ADM-APPCONFIG/reset_password",
      },
    ],
  },
];

// Function to get the appropriate routes based on user type
// This is called dynamically each time routes are needed
export const getPartnerRoutes = () => {
  const userType = getUserType();
  console.log("[PartnerRoute] User type:", userType);

  if (userType === "CHANNEL_PARTNER_ORG") {
    console.log("[PartnerRoute] Using CHANNEL_PARTNER routes (commission-only)");
    return channelPartnerRoutes;
  } else {
    console.log("[PartnerRoute] Using regular PARTNER routes (includes tickets & wallet)");
    return regularPartnerRoutes;
  }
};

// For backward compatibility - but this will be called fresh each time the module is imported
// after a page refresh
const partnerRoute = getPartnerRoutes();

export default partnerRoute;
